module.exports = __webpack_public_path__ + "media/images/Gestion de l’énergie-e404a0f09da636a21521cb1d670b5349.svg";